import React, { Component } from 'react';
import Card from '../../ui/Card';
import { TrendingUpIcon, TrendingDownIcon } from 'lucide-react';
const CampaignPerformanceTable: React.FC = () => {
  const campaigns = [{
    name: 'LED Headlamp Launch',
    channel: 'Digital',
    spend: 45.2,
    leads: 1240,
    conversions: 185,
    conversionRate: 14.9,
    roi: 342,
    trend: 'up',
    status: 'Active'
  }, {
    name: 'Digital Brand Campaign',
    channel: 'Digital',
    spend: 52.1,
    leads: 2140,
    conversions: 245,
    conversionRate: 11.4,
    roi: 412,
    trend: 'up',
    status: 'Active'
  }, {
    name: 'Aftermarket Summer Sale',
    channel: 'BTL',
    spend: 28.5,
    leads: 890,
    conversions: 156,
    conversionRate: 17.5,
    roi: 287,
    trend: 'up',
    status: 'Active'
  }, {
    name: 'EV Components Awareness',
    channel: 'ATL',
    spend: 62.8,
    leads: 1580,
    conversions: 142,
    conversionRate: 9.0,
    roi: 198,
    trend: 'up',
    status: 'Active'
  }, {
    name: 'Trade Show Participation',
    channel: 'Trade',
    spend: 75.6,
    leads: 1850,
    conversions: 178,
    conversionRate: 9.6,
    roi: 185,
    trend: 'down',
    status: 'Completed'
  }, {
    name: 'Dealer Network Expansion',
    channel: 'Trade',
    spend: 38.4,
    leads: 650,
    conversions: 98,
    conversionRate: 15.1,
    roi: 156,
    trend: 'down',
    status: 'Active'
  }, {
    name: 'Social Media - EV Focus',
    channel: 'Digital',
    spend: 32.8,
    leads: 1680,
    conversions: 198,
    conversionRate: 11.8,
    roi: 285,
    trend: 'up',
    status: 'Active'
  }, {
    name: 'TV Campaign - Safety',
    channel: 'ATL',
    spend: 68.5,
    leads: 920,
    conversions: 112,
    conversionRate: 12.2,
    roi: 168,
    trend: 'stable',
    status: 'Active'
  }];
  const getChannelColor = (channel: string) => {
    switch (channel) {
      case 'Digital':
        return 'bg-orange-100 text-orange-800';
      case 'ATL':
        return 'bg-blue-100 text-blue-800';
      case 'BTL':
        return 'bg-green-100 text-green-800';
      case 'Trade':
        return 'bg-purple-100 text-purple-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };
  const getStatusColor = (status: string) => {
    return status === 'Active' ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-600';
  };
  const getROIColor = (roi: number) => {
    if (roi >= 300) return 'text-green-600 font-bold';
    if (roi >= 200) return 'text-green-600';
    if (roi >= 150) return 'text-yellow-600';
    return 'text-gray-700';
  };
  return <Card className="p-6" data-id="element-6797">
      <div className="flex items-center justify-between mb-4" data-id="element-6798">
        <div data-id="element-6799">
          <h3 className="text-lg font-semibold text-gray-800" data-id="element-6800">
            Top Performing Campaigns
          </h3>
          <p className="text-sm text-gray-600" data-id="element-6801">
            Campaign performance with spend, leads, and ROI
          </p>
        </div>
        <div className="text-sm text-gray-500" data-id="element-6802">
          {campaigns.filter(c => c.status === 'Active').length} Active
          Campaigns
        </div>
      </div>
      <div className="overflow-x-auto" data-id="element-6803">
        <table className="w-full" data-id="element-6804">
          <thead data-id="element-6805">
            <tr className="border-b-2 border-gray-300" data-id="element-6806">
              <th className="text-left py-3 px-4 text-sm font-bold text-gray-700" data-id="element-6807">
                Campaign
              </th>
              <th className="text-center py-3 px-4 text-sm font-bold text-gray-700" data-id="element-6808">
                Channel
              </th>
              <th className="text-right py-3 px-4 text-sm font-bold text-gray-700" data-id="element-6809">
                Spend (₹L)
              </th>
              <th className="text-right py-3 px-4 text-sm font-bold text-gray-700" data-id="element-6810">
                Leads
              </th>
              <th className="text-right py-3 px-4 text-sm font-bold text-gray-700" data-id="element-6811">
                Conversions
              </th>
              <th className="text-right py-3 px-4 text-sm font-bold text-gray-700" data-id="element-6812">
                Conv. Rate
              </th>
              <th className="text-right py-3 px-4 text-sm font-bold text-gray-700" data-id="element-6813">
                ROI %
              </th>
              <th className="text-center py-3 px-4 text-sm font-bold text-gray-700" data-id="element-6814">
                Trend
              </th>
              <th className="text-center py-3 px-4 text-sm font-bold text-gray-700" data-id="element-6815">
                Status
              </th>
            </tr>
          </thead>
          <tbody data-id="element-6816">
            {campaigns.map((campaign, index) => <tr key={index} className="border-b border-gray-100 hover:bg-gray-50" data-id="element-6817">
                <td className="py-3 px-4 text-sm font-medium text-gray-800" data-id="element-6818">
                  {campaign.name}
                </td>
                <td className="py-3 px-4 text-center" data-id="element-6819">
                  <span className={`inline-flex px-2.5 py-0.5 rounded-full text-xs font-medium ${getChannelColor(campaign.channel)}`} data-id="element-6820">
                    {campaign.channel}
                  </span>
                </td>
                <td className="py-3 px-4 text-sm text-right text-gray-700" data-id="element-6821">
                  {campaign.spend}
                </td>
                <td className="py-3 px-4 text-sm text-right text-gray-700" data-id="element-6822">
                  {campaign.leads.toLocaleString()}
                </td>
                <td className="py-3 px-4 text-sm text-right font-medium text-gray-800" data-id="element-6823">
                  {campaign.conversions}
                </td>
                <td className="py-3 px-4 text-sm text-right text-gray-700" data-id="element-6824">
                  {campaign.conversionRate.toFixed(1)}%
                </td>
                <td className={`py-3 px-4 text-sm text-right ${getROIColor(campaign.roi)}`} data-id="element-6825">
                  {campaign.roi}%
                </td>
                <td className="py-3 px-4 text-center" data-id="element-6826">
                  {campaign.trend === 'up' && <TrendingUpIcon size={16} className="inline text-green-600" data-id="element-6827" />}
                  {campaign.trend === 'down' && <TrendingDownIcon size={16} className="inline text-red-600" data-id="element-6828" />}
                  {campaign.trend === 'stable' && <span className="text-gray-400" data-id="element-6829">—</span>}
                </td>
                <td className="py-3 px-4 text-center" data-id="element-6830">
                  <span className={`inline-flex px-2.5 py-0.5 rounded-full text-xs font-medium ${getStatusColor(campaign.status)}`} data-id="element-6831">
                    {campaign.status}
                  </span>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
      <div className="mt-4 pt-4 border-t border-gray-200" data-id="element-6832">
        <div className="grid grid-cols-5 gap-4 text-sm" data-id="element-6833">
          <div className="text-center" data-id="element-6834">
            <div className="text-gray-600" data-id="element-6835">Total Spend</div>
            <div className="text-xl font-bold text-gray-900" data-id="element-6836">
              ₹{campaigns.reduce((sum, c) => sum + c.spend, 0).toFixed(1)} L
            </div>
          </div>
          <div className="text-center" data-id="element-6837">
            <div className="text-gray-600" data-id="element-6838">Total Leads</div>
            <div className="text-xl font-bold text-blue-600" data-id="element-6839">
              {campaigns.reduce((sum, c) => sum + c.leads, 0).toLocaleString()}
            </div>
          </div>
          <div className="text-center" data-id="element-6840">
            <div className="text-gray-600" data-id="element-6841">Total Conversions</div>
            <div className="text-xl font-bold text-green-600" data-id="element-6842">
              {campaigns.reduce((sum, c) => sum + c.conversions, 0)}
            </div>
          </div>
          <div className="text-center" data-id="element-6843">
            <div className="text-gray-600" data-id="element-6844">Avg Conv. Rate</div>
            <div className="text-xl font-bold text-purple-600" data-id="element-6845">
              {(campaigns.reduce((sum, c) => sum + c.conversions, 0) / campaigns.reduce((sum, c) => sum + c.leads, 0) * 100).toFixed(1)}
              %
            </div>
          </div>
          <div className="text-center" data-id="element-6846">
            <div className="text-gray-600" data-id="element-6847">Avg ROI</div>
            <div className="text-xl font-bold text-green-600" data-id="element-6848">
              {(campaigns.reduce((sum, c) => sum + c.roi, 0) / campaigns.length).toFixed(0)}
              %
            </div>
          </div>
        </div>
      </div>
    </Card>;
};
export default CampaignPerformanceTable;